import { AddDeviceToOrganisationQueryArg } from '../types/query-arg';
import { AddDeviceToOrganisationQueryBody } from '../types/query-body';

export const addDeviceToOrganisationQueryBody = ({
  device: { endpointId },
  organisationId,
}: AddDeviceToOrganisationQueryArg): AddDeviceToOrganisationQueryBody => ({
  actionType: 'AddOrganisation',
  endpointId,
  update: { organisationId },
});
